import { D, S } from "@mobily/ts-belt";
import PropTypes from "prop-types";
import * as React from "react";
import { useDebounce } from "../../../hooks";
import s from "./SearchBar.module.css";

const SearchIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="M21 21l-4.35-4.35" />
  </svg>
);

const ClearIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

export default function SearchBar({ filter, setFilter }) {
  const [query, setQuery] = React.useState(() => filter.name || "");

  const setFilterAndRestoreRank = React.useCallback(
    (fn) => setFilter((filter) => D.merge(fn(filter), { cursor: "" })),
    [setFilter],
  );

  useDebounce(
    () => {
      const name = S.trim(query);

      if (name === (filter.name || "")) {
        return;
      }

      if (!name) {
        setFilterAndRestoreRank(D.merge({ name: "" }));
      } else if (name.length >= 3) {
        setFilterAndRestoreRank(D.merge({ name }));
      }
    },
    320,
    [query],
  );

  return (
    <div className={s.searchField}>
      <SearchIcon />
      <input
        className={s.searchInput}
        type="text"
        placeholder="Search talent, characters, products..."
        aria-label="Search products"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {Boolean(query) && (
        <button
          type="button"
          className={s.clearBtn}
          onClick={() => setQuery("")}
          aria-label="Clear search"
        >
          <ClearIcon />
        </button>
      )}
    </div>
  );
}

SearchBar.propTypes = {
  filter: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  setFilter: PropTypes.func.isRequired,
};
